import _definePage_default_0 from '/builds/webdev/code-wookies/swift-benefits-invoices/invoice-tracking-ui/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/builds/webdev/code-wookies/swift-benefits-invoices/invoice-tracking-ui/src/pages/admin/index.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: '/',
      component: () => import('/builds/webdev/code-wookies/swift-benefits-invoices/invoice-tracking-ui/src/pages/index.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/builds/webdev/code-wookies/swift-benefits-invoices/invoice-tracking-ui/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/AccessDenied',
    name: '/AccessDenied',
    component: () => import('/builds/webdev/code-wookies/swift-benefits-invoices/invoice-tracking-ui/src/pages/AccessDenied.vue'),
    /* no children */
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/admin/',
          component: () => import('/builds/webdev/code-wookies/swift-benefits-invoices/invoice-tracking-ui/src/pages/admin/index.vue'),
          /* no children */
        },
        _definePage_default_2
      )
    ],
  },
  {
    path: '/error',
    name: '/error',
    component: () => import('/builds/webdev/code-wookies/swift-benefits-invoices/invoice-tracking-ui/src/pages/error.vue'),
    /* no children */
  },
  {
    path: '/NotFound',
    name: '/NotFound',
    component: () => import('/builds/webdev/code-wookies/swift-benefits-invoices/invoice-tracking-ui/src/pages/NotFound.vue'),
    /* no children */
  },
  {
    path: '/PayPal',
    /* internal name: '/PayPal' */
    /* no component */
    children: [
      {
        path: 'Success',
        name: '/PayPal/Success',
        component: () => import('/builds/webdev/code-wookies/swift-benefits-invoices/invoice-tracking-ui/src/pages/PayPal/Success.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

